
// ----- Notes -----
// A maximum of 20 posts can be loaded due to the app being in sandbox mode on instagram

// How to get an access token:
// http://jelled.com/instagram/access-token

// API Endpoints:
// https://www.instagram.com/developer/endpoints/

// Model guide example:
// https://www.instagram.com/selcukcura/media/
// {{model.user.username}}, {{likes}} likes

// user data example using userId and accessToken:
// https://api.instagram.com/v1/users/4622774/?access_token=4622774.7cbaeb5.ec8c5041b92b44ada03e4a4a9153bc54

$( window ).on('load', function() {
  
  var feedHTML = 
     
    
    // modal
      '<div class="main_insta"><a class="more1" data-mfp-src=""  href="" rel="gal"><div class="fs-entry-container insta-feed img-featured-container"><div class="fs-timeline-entry" style="cursor:pointer;background-image:url({{image}})"><div class="fs-text-container">'+
                
               '<div class="fs-service-icon"><i class="icon-instagram"></i></div>'+
                
              '</div></div></div>'+
  
    // modal
              '</a><div class="post-modals w3-animate-opacity modal product_section thumbnail_position--bottom-thumbnails product_slideshow_animation--none hidden" id=""><div class="insta-container">'+
                '<div class="fs-detail-left eight columns"><div class="product_gallery">{{model.template}}</div></div>'+

              '<div class="fs-detail-right six columns">'+
      		'<div class="insta-arrows"><span class="icon-arrow-left"></span><span class="icon-arrow-right"></span></div>'+
              '<div class="btn-close">'+
                  '<div class="icon-close"></div>'+
                '</div>'+
  				'<div class="post-modal-body">'+
      			  '<div class="post-modal-meta-container" style="display:none">'+
                    '<p class="likes"><i class="fa fa-heart"></i> {{likes}}</p>'+
                    '<p class="comments"><i class="icon icon-chatbubble"></i> {{comments}}</p>'+
                  '</div>'+
                  '<div class="post-modal-caption-container">'+
                    '<p class="caption-feed">{{caption}}</p>'+
      				'<div class="fs-post-infos"><a href="{{link}}">MACHINE + FABRIC // INSTAGRAM // {{model.created_time}}</a></div>'+
                  '</div>'+
                 '</div></div>'+
              '</div></div></div>'
  
  var galleryFeed = new Instafeed({
    target: "instafeed-gallery-feed",
    get: "user",
    userId: 2319923577,
    accessToken: "2319923577.d90570a.c957a7fd7cf74780b8149c92d3a086eb",
    resolution: "standard_resolution",
    useHttp: "true",
    limit: 12,
     filter: function(image) {
            if (image.type == 'image') {
                image.template = '<img data-type="'+ image.type +'" src="' + image.images.standard_resolution.url + '" />';
            } else if (image.type == 'carousel') {
           
              var get_image = '';
              get_image += '<div class="insta-carousel"><ul class="slide">';
              for(i=0;i<image.carousel_media.length;i++){ 
                get_image += '<li><img data-type="'+ image.type +'" src="' + image.carousel_media[i].images.standard_resolution.url + '" /></li>';
              }
              get_image += '</ul></div>';
               image.template = get_image;
            } else if(image.type == 'video') {
             // image.template = '<img data-type="'+ image.type +'" src="' + image.images.standard_resolution.url + '" />';
                image.template = '<video width="100%" controls loop><source src="' + image.videos.standard_resolution.url + '" type="video/mp4"/></video>';
            }
       
           var date = new Date(image.created_time*1000);

            m = date.getMonth();
            d = date.getDate();
            y = date.getFullYear();

            var month_names = new Array ( );
            month_names[month_names.length] = "January";
            month_names[month_names.length] = "February";
            month_names[month_names.length] = "March";
            month_names[month_names.length] = "April";
            month_names[month_names.length] = "May";
            month_names[month_names.length] = "June";
            month_names[month_names.length] = "July";
            month_names[month_names.length] = "Augst";
            month_names[month_names.length] = "September";
            month_names[month_names.length] = "October";
            month_names[month_names.length] = "November";
            month_names[month_names.length] = "December";

            var thetime =  d + ' ' + month_names[m] +' ' + y;

            image.created_time = thetime;       
       
            return true;
        },
    template: feedHTML,
   
    after: function() {
     
      $('.insta-carousel').flexslider({
          touch: true,
          controlNav: true,
          animation: "slide",
         // slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000
        });
      
      jQuery('.main_insta').each(function(e){
      	jQuery(this).find('.more1').attr('href','#insta'+$(this).index());
        	jQuery(this).find('.more1').attr('data-mfp-src','#insta'+$(this).index());
        jQuery(this).find('.post-modals').attr('id','insta'+$(this).index());   
         jQuery(this).find('.more1').attr('id','feed'+$(this).index());
      });
      var $headerContainer = $('.header-container'), 
          $imagePost = $('.more1'),
          totalImages = $imagePost.length,
          $postModalContainer = $('.post-modal-container'),
          $postModal = $('.post-modals'),
          $postModalBackdrop = $('.post-modal-backdrop'),
          counter = 0;
      
      // remove all $headerContainer except one from template function and move to header
      for (i=1; i < totalImages; i++) {
        console.log('remove', i)
      }
      
     $imagePost.on('click', function() {
        var postIndex = $(this).attr('id');
        console.log('clicked post', postIndex);
        $('.post-modals').removeClass('show');
       $('#'+postIndex).next('.post-modals').removeClass('hidden');
        $('#'+postIndex).next('.post-modals').addClass('show');
        $postModalBackdrop.addClass('show');
        $('body').addClass('popup-open');
      });
      
      $('.btn-close').on('click', function() {
        var postIndex = $(this).index();
        console.log('modal closed', postIndex)
         $('body').removeClass('popup-open');
        $(this).parents('.post-modals').removeClass('show');
        $postModal.eq(postIndex).addClass('hidden');
         $postModal.addClass('hidden');
        $postModalBackdrop.removeClass('show');
      });
      
      $('.insta-arrows .icon-arrow-right').on('click', function() {
        if($(this).parents('.main_insta').next('.main_insta').find('.post-modals').length){
          jQuery(this).css('pointer-events','default');
          jQuery('.icon-arrow-right::before').css('color','#000');
          jQuery(this).parents('.main_insta').next('.main_insta').find('.post-modals').removeClass('disable');    
           jQuery(this).parents('.main_insta').find('.post-modals').removeClass('show');
          
          $('.post-modals').removeClass('show');
          $('.post-modals').addClass('hidden');
         
           $(this).parents('.main_insta').next('.main_insta').find('.post-modals').removeClass('hidden');
          $(this).parents('.main_insta').next('.main_insta').find('.post-modals').addClass('show'); 
        }else{
          jQuery(this).css('pointer-events','none');
          jQuery('.icon-arrow-right::before').css('color','#000000b3');
         jQuery(this).parents('.main_insta').next('.main_insta').find('.post-modals').addClass('disable');
        }
      });

      $('.insta-arrows .icon-arrow-left').on('click', function() { 
        if($(this).parents('.main_insta').prev('.main_insta').find('.post-modals').length){
          jQuery(this).css('pointer-events','default');
          jQuery('.icon-arrow-right::before').css('color','#000');
          jQuery(this).parents('.main_insta').prev('.main_insta').find('.post-modals').removeClass('disable');    
           jQuery(this).parents('.main_insta').find('.post-modals').removeClass('show');
          
          $('.post-modals').removeClass('show');
          $('.post-modals').addClass('hidden');
         
           $(this).parents('.main_insta').prev('.main_insta').find('.post-modals').removeClass('hidden');
          $(this).parents('.main_insta').prev('.main_insta').find('.post-modals').addClass('show'); 
        }else{
          jQuery(this).css('pointer-events','none');
          jQuery('.icon-arrow-right::before').css('color','#000000b3');
         jQuery(this).parents('.main_insta').prev('.main_insta').find('.post-modals').addClass('disable');
        }
      });
      
      $postModalBackdrop.on('click', function() {
        $postModal.removeClass('show');
        $postModalBackdrop.removeClass('show');
        jQuery('body').removeClass('popup-open');
      });

      // disable button if no more results to load
      if (!this.hasNext()) {
        console.log('no more posts to load');
        $btnInstafeedLoad.attr('disabled', 'disabled');
        $btnInstafeedLoad.css('pointer-events','none');
      }
      
    }
  });
  
  galleryFeed.run();

  var $btnInstafeedLoad = $("#btn-instafeed-load");
  $btnInstafeedLoad.on('click', function() {
    console.log('btn clicked - load posts')
    galleryFeed.next();
  });
  
});